module.exports = __webpack_public_path__ + "static/media/primary2.1b60984e.png";